import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: "root" })
export class PageContentFunctionService {

  private service = 'PageContentFunctionService';

  constructor(private http: HttpClient) {

  }

  public getList(pageContentId: number):any {
    return this.http.get(`api/${this.service}/list/${pageContentId}`);
  }
}
